import * as React from 'react';

export function jsonToHtml(json: any): string {
    let html = "<div class='padded json-pairs of-a'>";
    Object.entries(json).forEach(([key, val]) => {
        let objectPropsValue;
        if (!!val && typeof val === 'string' && val.startsWith('{')) {
            try {
                objectPropsValue = JSON.parse(val);
            } catch (e) {
                console.error(e);
            }
        }
        if (typeof objectPropsValue === 'object') {
            html += `<div class='collapsible-panel'>
                <header>
                    <i class='iki iki-chevron-right'/>
                    <span>${key}</span>
                </header>`;
            Object.entries(objectPropsValue).map(([objKey, objVal]) => {
                html += `<div style="margin-left: 2em;"><span>${objKey}: <span class="break-text" style="max-width: 500px;">${objVal}</span></span></div>`;
            });
            html += `</div>`;
        } else {
            html += `<div class='text-nowrap'>${key}:&nbsp; <span class="break-text" style="max-width: 500px;">${val == undefined ? '' : val}</span></div>`;
        }
    });
    return (html += '<div>');
}

export class JsonToHtmlEl extends React.Component<{
    data: object;
    asTable: boolean;
    prettyKeys: boolean;
}> {
    static defaultProps = {
        asTable: false,
        prettyKeys: false,
    };

    render() {
        const entries = Object.entries(this.props.data);

        if (this.props.asTable) {
            return (
                <table>
                    {entries.map(([key, val]) => (
                        <tr key={key}>
                            <td style={{ paddingRight: 20, textTransform: this.props.prettyKeys ? 'capitalize' : 'none' }} title={key}>
                                {this.getKeyString(key)}
                            </td>
                            <td>{val + ''}</td>
                        </tr>
                    ))}
                </table>
            );
        }

        return (
            <div className='json-pairs'>
                {entries.map(([key, val]) => {
                    if (String(val).startsWith('http://') || String(val).startsWith('https://')) {
                        return (
                            <div key={key}>
                                {this.getKeyString(key)}:{' '}
                                <a href={val} target='_blank' rel='noopener'>
                                    {val}
                                </a>
                            </div>
                        );
                    } else {
                        return (
                            <div key={key}>
                                {this.getKeyString(key)}: {val + ''}
                            </div>
                        );
                    }
                })}
            </div>
        );
    }

    getKeyString = (key: string): string => {
        if (this.props.prettyKeys) {
            return key.toString().replace(/_/gi, ' ');
        }
        return key.toString();
    };
}
